import React from "react";

import hairred1 from "../assets/HairReduction/img1.png";
import hairred2 from "../assets/HairReduction/img2.png";
import hairred3 from "../assets/HairReduction/img3.png";
import bodyscup1 from "../assets/bodysculpting/img1.png";
import bodyscup2 from "../assets/bodysculpting/img2.png";
import bodyscup3 from "../assets/bodysculpting/img3.png";
import analysers1 from "../assets/analysers/img1.png";
import analysers2 from "../assets/analysers/img2.png";
import hydra1 from "../assets/hydrafacial/img1.png";
import hydra2 from "../assets/hydrafacial/img2.png";
import skinlift1 from "../assets/skinlifting/img1.png";
import skinlift2 from "../assets/skinlifting/img2.png";
import skintight1 from "../assets/skin-tight/img1.png";
import skintight2 from "../assets/skin-tight/img2.png";
import skintight3 from "../assets/skin-tight/img3.png";
import pigment1 from "../assets/pigmentremoval/img1.png";
import hairgrowth from "../assets/hair-regrowth/HAIR-BOOSTER.png";

const equipmentData = [
  {
    name: "HydraFacial Machine",
    category: "Pigment Removal",
    image: pigment1,
    pdfLink: "https://pdfobject.com/pdf/sample.pdf",
  },
  {
    name: "Laser Machine",
    category: "Hair Regrowth",
    image: hairgrowth,
    pdfLink: "/path/to/laser-manual.pdf",
  },
  {
    name: "Oxygen Machine",
    category: "Skin Tightening",
    image: skintight1,
    pdfLink: "/path/to/oxygen-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Skin Tightening",
    image: skintight2,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Skin Tightening",
    image: skintight3,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Skin Lifting",
    image: skinlift1,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Skin Lifting",
    image: skinlift2,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Hydra Facial",
    image: hydra1,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Hydra Facial",
    image: hydra2,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Analyser",
    image: analysers1,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Analyser",
    image: analysers2,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Body Sculpting",
    image: bodyscup1,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Body Sculpting",
    image: bodyscup2,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Body Sculpting",
    image: bodyscup3,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Hair Reduction",
    image: hairred1,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Hair Reduction",
    image: hairred2,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
  {
    name: "Cryo Machine",
    category: "Hair Reduction",
    image: hairred3,
    pdfLink: "/path/to/cryo-manual.pdf",
  },
];

const Equipment = () => {
  return (
    <>
      <div className="font-sans py-4 mx-auto mt-10 lg:max-w-6xl md:max-w-4xl max-sm:max-w-md">
        <h2 className="text-4xl font-extrabold text-gray-800 text-center mb-5">
          Top Equipment
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-6 gap-12">
          {equipmentData.map((equipment, index) => (
            <div
              key={index}
              className="bg-gray-100 p-3 rounded-lg group overflow-hidden cursor-pointer relative z-50 hover:before:bg-black before:absolute before:inset-0 before:opacity-20 before:transition-all"
            >
              <div className="w-full h-[300px] overflow-hidden mx-auto aspect-w-16 aspect-h-8">
                <img
                  src={equipment.image}
                  alt={equipment.name}
                  className="h-full w-full object-contain"
                />
              </div>

              <div className="absolute mx-auto left-0 right-0 -bottom-80 group-hover:bottom-2 bg-white w-11/12 p-3 rounded-lg transition-all duration-300">
                <div className="text-center">
                  <h3 className="text-base font-bold text-gray-800">
                    {equipment.name}
                  </h3>
                  <h4 className="text-lg text-blue-600 font-bold mt-2">
                    {equipment.category}
                  </h4>
                </div>

                <div className="flex justify-center space-x-1 mt-4">
                  <div className="font-[sans-serif] w-max mx-auto bg-white border-2 border-[#333] flex rounded overflow-hidden">
                    <a
                      href={equipment.pdfLink}
                      download
                      target="_blank"
                      className="px-5 py-2.5 flex items-center text-[#333] text-sm tracking-wider font-semibold border-none outline-none hover:text-white hover:bg-[#333] active:bg-[#111] transition-all"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17px"
                        fill="currentColor"
                        className="mr-3"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 16a.749.749 0 0 1-.542-.232l-5.25-5.5A.75.75 0 0 1 6.75 9H9.5V3.25c0-.689.561-1.25 1.25-1.25h2.5c.689 0 1.25.561 1.25 1.25V9h2.75a.75.75 0 0 1 .542 1.268l-5.25 5.5A.749.749 0 0 1 12 16zm10.25 6H1.75C.785 22 0 21.215 0 20.25v-.5C0 18.785.785 18 1.75 18h20.5c.965 0 1.75.785 1.75 1.75v.5c0 .965-.785 1.75-1.75 1.75z" />
                      </svg>
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Equipment;
